module.exports = __webpack_public_path__ + "img/eclipse-loader.7ef833d2.svg";